"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectMembersTable = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const icons_1 = require("@ant-design/icons");
const RemoveProjectParticipantModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/RemoveProjectParticipantModalComponent");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const CurrentProjectProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentProjectProvider");
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const ProjectParticipantModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ProjectParticipantModalComponent");
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const CopyablePrincipalComponent_1 = require("src/configeek_assets/src/components/common/widget/CopyablePrincipalComponent");
const AutoWrapContainer_1 = require("src/configeek_assets/src/components/loggedIn/common/AutoWrapContainer");
const ProjectMembersTable = () => {
    var _a;
    const isMounted = (0, isMounted_1.default)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectParticipantsDataContext = (0, ProjectParticipantsDataProvider_1.useProjectParticipantsDataContext)();
    const { inProgress } = projectParticipantsDataContext.participants.status;
    const [pagination] = (0, react_1.useState)({ hideOnSinglePage: false, defaultPageSize: process.env.NODE_ENV === "development" ? 10 : 25, showSizeChanger: true, pageSizeOptions: [10, 25, 50, 100], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` });
    const [participantViewInModal, setParticipantViewInModal] = (0, react_1.useState)();
    //edit participant
    const [editParticipantModalVisible, setEditParticipantModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onEditParticipantModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setEditParticipantModalVisible({ visible: false });
        }
    }, [isMounted]);
    //remove participant
    const [removeParticipantModalVisibility, setRemoveParticipantModalVisibility] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onRemoveParticipantModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setRemoveParticipantModalVisibility({ visible: false });
        }
    }, [isMounted]);
    const onClickMenuEdit = (0, react_1.useCallback)((record) => {
        setParticipantViewInModal(record.participantView);
        setEditParticipantModalVisible({ visible: true, nonce: editParticipantModalVisible.nonce + 1 });
    }, [editParticipantModalVisible.nonce]);
    const onClickMenuRemove = (0, react_1.useCallback)((record) => {
        setParticipantViewInModal(record.participantView);
        setRemoveParticipantModalVisibility({ visible: true, nonce: removeParticipantModalVisibility.nonce + 1 });
    }, [removeParticipantModalVisibility.nonce]);
    const tableColumns = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return [
            {
                title: "Principal",
                render: (value, record) => React.createElement(CopyablePrincipalComponent_1.CopyablePrincipalComponent, { principal: record.principal, truncateLength: 99 }),
                sorter: (a, b) => a.principal.localeCompare(b.principal),
            },
            {
                title: "Name",
                render: (value, record) => React.createElement(AutoWrapContainer_1.AutoWrapContainer, null, record.name),
                sorter: (a, b) => a.name.localeCompare(b.name)
            },
            {
                title: "Role",
                render: (value, record) => record.role,
                sorter: (a, b) => a.role.localeCompare(b.role)
            },
            {
                title: "Time, UTC",
                render: (value, record) => DateTimeUtils_1.DateTimeUtils.formatDate(record.createdTimeMillis, "dayTimeSeconds"),
                sorter: (a, b) => a.createdTimeMillis - b.createdTimeMillis
            },
            {
                render: (value, record) => {
                    const isOwnerRole = appICUtils_1.ParticipantRoleUtils.isOwnerRole(record.participantView.role);
                    const canBeEdited = true;
                    const canBeRemoved = !isOwnerRole;
                    const items = [];
                    if (canBeEdited) {
                        items.push({
                            key: "edit",
                            label: "Edit",
                            onClick: () => onClickMenuEdit(record)
                        });
                    }
                    if (canBeRemoved) {
                        items.push({
                            key: "remove",
                            label: "Remove",
                            danger: true,
                            onClick: () => onClickMenuRemove(record)
                        });
                    }
                    const menu = React.createElement(antd_1.Menu, { items: items });
                    return React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight" },
                        React.createElement(antd_1.Button, { type: "link", icon: React.createElement(icons_1.MoreOutlined, { style: { fontSize: "20px" } }) }));
                },
                width: "1%"
            }
        ];
    }, [onClickMenuEdit, onClickMenuRemove], lodash_1.default.isEqual);
    const dataSource = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        var _a;
        return lodash_1.default.sortBy(lodash_1.default.map((_a = projectParticipantsDataContext.participants.data) === null || _a === void 0 ? void 0 : _a.participantViews, participantView => {
            return {
                participantView: participantView,
                name: participantView.name,
                role: appICUtils_1.ParticipantRoleUtils.getRoleName(participantView.role),
                principal: participantView.principal.toText(),
                createdTimeMillis: participantView.createdTimeSeconds * 1000
            };
        }), v => -v.createdTimeMillis);
    }, [(_a = projectParticipantsDataContext.participants.data) === null || _a === void 0 ? void 0 : _a.participantViews], lodash_1.default.isEqual);
    return React.createElement(React.Fragment, null,
        React.createElement(ProjectParticipantModalComponent_1.ProjectParticipantModalComponent, { key: `editProjectParticipant${editParticipantModalVisible.nonce}`, visible: editParticipantModalVisible.visible, onDestroy: onEditParticipantModalDestroy, projectView: currentProjectContext.projectData.view.project, participantView: participantViewInModal }),
        React.createElement(RemoveProjectParticipantModalComponent_1.RemoveProjectParticipantModalComponent, { key: `${removeParticipantModalVisibility.nonce}`, visible: removeParticipantModalVisibility.visible, onDestroy: onRemoveParticipantModalDestroy, projectView: currentProjectContext.projectData.view.project, participantView: participantViewInModal }),
        React.createElement(antd_1.Table, { dataSource: dataSource, columns: tableColumns, loading: inProgress, rowKey: record => `${record.principal}`, showSorterTooltip: false, pagination: pagination }));
};
exports.ProjectMembersTable = ProjectMembersTable;
